import { NavigationGuard } from 'vue-router';
import store from '../store';

function resolveDefaultTeamId(): number | undefined {
   const userInfo = store.state.userInfo?.userInfo;
   if (!userInfo) return undefined;

   return userInfo.default_team?.id ?? userInfo.default_team_id ?? userInfo.teams?.[0]?.id ?? undefined;
}

const TEAM_GUARD: NavigationGuard = async (to, from, next) => {
   if (store.state.userInfo?.userInfo?.is_contact_user) {
      if (!Object.prototype.hasOwnProperty.call(to.query, 'team_id')) return next();

      const query = { ...to.query };
      delete query.team_id;
      return next({ ...to, query, replace: true });
   }

   if (to.query.team_id) return next();

   const teamId = resolveDefaultTeamId();
   if (!teamId) return next();

   return next({ ...to, query: { ...to.query, team_id: String(teamId) } });
};

export default TEAM_GUARD;
